import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'

class CloudwaysFailed extends React.Component {
	render() {
		const { migrate } = this.props
		const migrationError = migrate.getIn(['errors', 'message'])
		return <div className="cws d-flex">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="migration-box text-center">
							<div>
								<img className="" src="/assets/cloudways/cws-exclamation.svg" alt=""/>
								<h1 className="font-36 color-0E134F proxima-regular my-1">
									Migration Failed
								</h1>
								<p className="v-center py-2 site-urls" style={{justifyContent: 'center'}}>
									<a href={migrate.get('source_site')} target="_blank" rel="noreferrer" className="color-2D38BB  proxima-regular font-18 td-none">
										{migrate.get('source_site')}
									</a>
									<img className="arrow-icon" src="/assets/cloudways/cws-blue-arrow.svg" alt=""/>
									<a href={migrate.get('destination_site')} target="_blank" rel="noreferrer" className="color-2D38BB  proxima-regular font-18 td-none">
										{migrate.get('destination_site')}
									</a>
								</p>
								<div className="cw-border-1 mt-2 mb-4"/>
							</div>
							<div className="bv-error center-block mt-3">{ migrationError }</div>
							<div className="mt-5 mb-5">
								<h6 className="font-16 color-0E134 proxima-regular">We want to help! Drop us a line via a support ticket and we’ll help you out.</h6>
								<a href="https://support.cloudways.com/" target="_blank" rel="noreferrer" className="green-button mt-2 inline-block"> OPEN A TICKET</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}         
}           

CloudwaysFailed.propTypes = {
	migrate: ImmutablePropTypes.map
}

export default CloudwaysFailed
